import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useState } from "react";
import { checkTestFlag } from "@/common/config/websiteConfig";
import useHelpers from "@hooks/useHelpers";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { trackEvents } from "@/common/events/events";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useTranslation } from "@i18n";
import { onPushDataLayer } from "@/utils/events";
import { useFullPageData } from "@/common/Contexts/FullPageContext";

// FIXME: chinees is not a car condition
// TODO: in Finance Calculator the wrong logic used

var _navigateToColorVariation = function _navigateToColorVariation(post_id, g4_data, navigateToHard) {
  return function (color) {
    var _color$name_en;
    trackEvents("car_color_selected", {
      referral_location: "post_details",
      post_id: post_id,
      selected_color: (_color$name_en = color === null || color === void 0 ? void 0 : color.name_en) !== null && _color$name_en !== void 0 ? _color$name_en : '',
      post_make: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_make,
      post_model: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_model
    });
    navigateToHard("/cardetail/".concat(color.post_id));
  };
};
var _navigateToLeadPage = function _navigateToLeadPage(setSubmissionSource, g4_data, navigateTo, postId, isFinance, hasTamara, CarBNPLOptions) {
  return function () {
    var bnplTypes = new Set(CarBNPLOptions.map(function (op) {
      return op.type;
    }));
    var bnplFlags = ["tamara", "tabby", "amwal"].reduce(function (acc, type) {
      acc["is_".concat(type)] = bnplTypes.has(type) ? "yes" : "no";
      return acc;
    }, {});
    if (isFinance) {
      sessionStorage.removeItem("installment-calculator-".concat(postId));
      setSubmissionSource('car_detail');
      trackEvents("book_car", _objectSpread(_objectSpread({}, g4_data), {}, {
        post_trim: g4_data.post_ext,
        inventory_type_string: g4_data === null || g4_data === void 0 ? void 0 : g4_data.inventory_type_string
      }, bnplFlags));
    } else {
      cashCheckout1Event("checkout_lead", g4_data);
      trackEvents("book_car", _objectSpread(_objectSpread({}, g4_data), {}, {
        post_trim: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_ext
      }, bnplFlags));
    }
    navigateTo("/pre-checkout/".concat(postId));
  };
};
var PostDetailsContext = /*#__PURE__*/createContext(null);
export function usePostDetails() {
  return useContext(PostDetailsContext);
}
export default function PostDetailsContextProvider(_ref) {
  var children = _ref.children;
  var postViewApiResponseFullPageData = useFullPageData();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showContactNumbers = _useState[0],
    setShowContactNumbers = _useState[1];
  var _useState2 = useState(false),
    showOutSideWorkingHoursForm = _useState2[0],
    setShowOutSideWorkingHoursForm = _useState2[1];
  var _useState3 = useState((postViewApiResponseFullPageData === null || postViewApiResponseFullPageData === void 0 ? void 0 : postViewApiResponseFullPageData.postDetails) || null),
    postDetails = _useState3[0],
    setPostDetails = _useState3[1];
  var _useState4 = useState(false),
    howToBuyStoryOpen = _useState4[0],
    setHowToBuyStoryOpen = _useState4[1];
  var _useSubmissionSource = useSubmissionSource(),
    setSubmissionSource = _useSubmissionSource.setSubmissionSource;
  var getPostId = function getPostId() {
    var _postDetails$details;
    return Number(postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details = postDetails.details) === null || _postDetails$details === void 0 ? void 0 : _postDetails$details.id) || 0;
  };
  var isCashOnlyCar = function isCashOnlyCar() {
    var _postDetails$details2;
    if (checkTestFlag("TEST_HAVE_FINANCE") !== undefined) {
      return !checkTestFlag("TEST_HAVE_FINANCE");
    }
    return !(postDetails !== null && postDetails !== void 0 && (_postDetails$details2 = postDetails.details) !== null && _postDetails$details2 !== void 0 && _postDetails$details2.have_finance);
  };
  var isLimitedAvailability = function isLimitedAvailability() {
    var _postDetails$details3, _postDetails$details4, _postDetails$details5, _postDetails$details6;
    if (checkTestFlag("TEST_IS_LIMITED_QUANTITY") !== undefined) {
      return checkTestFlag("TEST_IS_LIMITED_QUANTITY");
    }
    return !!(postDetails !== null && postDetails !== void 0 && (_postDetails$details3 = postDetails.details) !== null && _postDetails$details3 !== void 0 && _postDetails$details3.limited_quantity && postDetails !== null && postDetails !== void 0 && (_postDetails$details4 = postDetails.details) !== null && _postDetails$details4 !== void 0 && (_postDetails$details5 = _postDetails$details4.details_card) !== null && _postDetails$details5 !== void 0 && (_postDetails$details6 = _postDetails$details5.is_new) !== null && _postDetails$details6 !== void 0 && _postDetails$details6.id);
  };
  var haveFinance = function haveFinance() {
    var _postDetails$details7;
    if (checkTestFlag("TEST_HAVE_FINANCE") !== undefined) {
      return checkTestFlag("TEST_HAVE_FINANCE");
    }
    return !!(postDetails !== null && postDetails !== void 0 && (_postDetails$details7 = postDetails.details) !== null && _postDetails$details7 !== void 0 && _postDetails$details7.have_finance);
  };
  var getG4_data = function getG4_data() {
    return (postDetails === null || postDetails === void 0 ? void 0 : postDetails.g4Data) || {};
  };
  var hasArboun = function hasArboun() {
    var _postDetails$footer;
    return !!(postDetails !== null && postDetails !== void 0 && (_postDetails$footer = postDetails.footer) !== null && _postDetails$footer !== void 0 && _postDetails$footer.arboun);
  };
  var getArboun = function getArboun() {
    var _postDetails$footer2;
    return Number(postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$footer2 = postDetails.footer) === null || _postDetails$footer2 === void 0 ? void 0 : _postDetails$footer2.arboun);
  };
  var helpers = {
    getG4_data: getG4_data,
    getPostId: getPostId,
    haveFinance: haveFinance,
    isCashOnlyCar: isCashOnlyCar,
    isLimitedAvailability: isLimitedAvailability,
    hasArboun: hasArboun,
    getArboun: getArboun,
    getMainImage: function getMainImage() {
      var _postDetails$gallery, _postDetails$gallery2, _postDetails$gallery3;
      return postDetails !== null && postDetails !== void 0 && (_postDetails$gallery = postDetails.gallery) !== null && _postDetails$gallery !== void 0 && _postDetails$gallery.images ? postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$gallery2 = postDetails.gallery) === null || _postDetails$gallery2 === void 0 ? void 0 : (_postDetails$gallery3 = _postDetails$gallery2.images[0]) === null || _postDetails$gallery3 === void 0 ? void 0 : _postDetails$gallery3.img_url : "";
    },
    isChinese: function isChinese() {
      var _postDetails$details8;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details8 = postDetails.details) === null || _postDetails$details8 === void 0 ? void 0 : _postDetails$details8.is_chinese;
    },
    getCarCondition: function getCarCondition() {
      var _postDetails$details9, _postDetails$details0, _postDetails$details1;
      return !(postDetails !== null && postDetails !== void 0 && (_postDetails$details9 = postDetails.details) !== null && _postDetails$details9 !== void 0 && (_postDetails$details0 = _postDetails$details9.details_card) !== null && _postDetails$details0 !== void 0 && (_postDetails$details1 = _postDetails$details0.is_new) !== null && _postDetails$details1 !== void 0 && _postDetails$details1.id) ? "used" : "new";
    },
    getCarBNPLOptions: function getCarBNPLOptions() {
      var _postDetails$details10;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details10 = postDetails.details) === null || _postDetails$details10 === void 0 ? void 0 : _postDetails$details10.bnpl_options;
    },
    mapFinanceCalculatorCarCondition: function mapFinanceCalculatorCarCondition() {
      var _details$details_card, _details$details_card2;
      var details = postDetails === null || postDetails === void 0 ? void 0 : postDetails.details;
      var isNew = !!(details !== null && details !== void 0 && (_details$details_card = details.details_card) !== null && _details$details_card !== void 0 && (_details$details_card2 = _details$details_card.is_new) !== null && _details$details_card2 !== void 0 && _details$details_card2.id);
      var condition = isNew ? "new" : "used";
      if (details !== null && details !== void 0 && details.is_chinese && condition === "new") {
        condition = "chinese";
      }
      return condition;
    },
    hasDamanProgram: function hasDamanProgram() {
      var _postDetails$details11, _postDetails$details12, _postDetails$details13;
      return (postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details11 = postDetails.details) === null || _postDetails$details11 === void 0 ? void 0 : (_postDetails$details12 = _postDetails$details11.details_card) === null || _postDetails$details12 === void 0 ? void 0 : (_postDetails$details13 = _postDetails$details12.is_new) === null || _postDetails$details13 === void 0 ? void 0 : _postDetails$details13.id) === 0;
    },
    getPostTitle: function getPostTitle() {
      var _postDetails$details14;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details14 = postDetails.details) === null || _postDetails$details14 === void 0 ? void 0 : _postDetails$details14.h1;
    },
    getPageTitle: function getPageTitle() {
      var _postDetails$details15;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details15 = postDetails.details) === null || _postDetails$details15 === void 0 ? void 0 : _postDetails$details15.title;
    },
    isPreOwned: function isPreOwned() {
      var _postDetails$details16;
      if (checkTestFlag("TEST_IS_IS_PREOWNED") !== undefined) {
        return checkTestFlag("TEST_IS_IS_PREOWNED");
      }
      return !!(postDetails !== null && postDetails !== void 0 && (_postDetails$details16 = postDetails.details) !== null && _postDetails$details16 !== void 0 && _postDetails$details16.is_preowned);
    },
    isMostPopular: function isMostPopular() {
      var _postDetails$options;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$options = postDetails.options) === null || _postDetails$options === void 0 ? void 0 : _postDetails$options.most_popular;
    },
    isCarReserved: function isCarReserved() {
      var _postDetails$footer3;
      if (checkTestFlag("TEST_IS_CAR_RESERVED") !== undefined) {
        return checkTestFlag("TEST_IS_CAR_RESERVED");
      }
      return (postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$footer3 = postDetails.footer) === null || _postDetails$footer3 === void 0 ? void 0 : _postDetails$footer3.reserved) == 1;
    },
    isCarUsed: function isCarUsed() {
      var _getG4_data;
      return ((_getG4_data = getG4_data()) === null || _getG4_data === void 0 ? void 0 : _getG4_data.post_condition) === "used";
    },
    hasDiscount: function hasDiscount() {
      var _postDetails$price, _postDetails$price$ol;
      return !!(postDetails !== null && postDetails !== void 0 && (_postDetails$price = postDetails.price) !== null && _postDetails$price !== void 0 && (_postDetails$price$ol = _postDetails$price.old_price) !== null && _postDetails$price$ol !== void 0 && _postDetails$price$ol.text_with_vat);
    },
    hasTamara: function hasTamara() {
      var _postDetails$details17;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details17 = postDetails.details) === null || _postDetails$details17 === void 0 ? void 0 : _postDetails$details17.has_tamara;
    },
    getStory: function getStory() {
      var story = postDetails === null || postDetails === void 0 ? void 0 : postDetails.story;
      var title = story === null || story === void 0 ? void 0 : story.cash_story.title;
      var image = story === null || story === void 0 ? void 0 : story.cash_story.img;
      // const storyData: IPostStory["cash_story"]["data"] =
      //     postDetails?.story?.cash_story.data;
      return {
        title: title,
        story: story,
        image: image
      };
    },
    getCarPrice: function getCarPrice() {
      var _postDetails$price2, _postDetails$price3, _postDetails$price3$o, _postDetails$price4, _postDetails$price4$f;
      var bestPrice = String(postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$price2 = postDetails.price) === null || _postDetails$price2 === void 0 ? void 0 : _postDetails$price2.vat_price.text);
      var fullPrice = String(postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$price3 = postDetails.price) === null || _postDetails$price3 === void 0 ? void 0 : (_postDetails$price3$o = _postDetails$price3.old_price) === null || _postDetails$price3$o === void 0 ? void 0 : _postDetails$price3$o.text_with_vat) || bestPrice;
      var financeMonthlyPrice = String(postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$price4 = postDetails.price) === null || _postDetails$price4 === void 0 ? void 0 : (_postDetails$price4$f = _postDetails$price4.finance_price) === null || _postDetails$price4$f === void 0 ? void 0 : _postDetails$price4$f.text);
      return {
        bestPrice: bestPrice,
        numberPrice: Number(bestPrice.replaceAll(",", "")) || 0,
        /**/
        fullPrice: fullPrice,
        financeMonthlyPrice: financeMonthlyPrice
      };
    },
    showImagesDisclaimer____WHY_THIS_NAME: function showImagesDisclaimer____WHY_THIS_NAME() {
      var _postDetails$gallery4, _postDetails$gallery5;
      if ((postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$gallery4 = postDetails.gallery) === null || _postDetails$gallery4 === void 0 ? void 0 : (_postDetails$gallery5 = _postDetails$gallery4.images) === null || _postDetails$gallery5 === void 0 ? void 0 : _postDetails$gallery5.length) > 0) {
        var _postDetails$gallery$, _postDetails$gallery$2;
        var exteriorImages = postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$gallery$ = postDetails.gallery.images.filter(function (item) {
          return (item === null || item === void 0 ? void 0 : item.img_type) === "exterior";
        })) === null || _postDetails$gallery$ === void 0 ? void 0 : _postDetails$gallery$.length;
        var interiorImages = postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$gallery$2 = postDetails.gallery.images.filter(function (item) {
          return (item === null || item === void 0 ? void 0 : item.img_type) === "interior";
        })) === null || _postDetails$gallery$2 === void 0 ? void 0 : _postDetails$gallery$2.length;
        return exteriorImages < 5 || interiorImages < 5;
      }
      return false;
    },
    getLowMileage: function getLowMileage() {
      var _postDetails$details18;
      return postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details18 = postDetails.details) === null || _postDetails$details18 === void 0 ? void 0 : _postDetails$details18.low_mileage_text;
    },
    isColorLight: function isColorLight(hexColor) {
      var hex = hexColor.replace('#', '');

      // Parse RGB
      var r = parseInt(hex.substring(0, 2), 16);
      var g = parseInt(hex.substring(2, 4), 16);
      var b = parseInt(hex.substring(4, 6), 16);

      // Perceived brightness formula
      var brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      return brightness >= 128;
    }
  };
  var actions = {
    showContactNumbers: function showContactNumbers() {
      setShowContactNumbers(true);
    },
    hideContactNumbers: function hideContactNumbers() {
      setShowContactNumbers(false);
    },
    showOutSideWorkingHoursForm: function showOutSideWorkingHoursForm() {
      onPushDataLayer("communication.click", "communication", "widget", "communication.click.bottom");
      setShowOutSideWorkingHoursForm(true);
    },
    hideOutSideWorkingHoursForm: function hideOutSideWorkingHoursForm() {
      setShowOutSideWorkingHoursForm(false);
    },
    openHowToBuyStory: function openHowToBuyStory() {
      setHowToBuyStoryOpen(true);
    },
    closeHowToBuyStory: function closeHowToBuyStory() {
      setHowToBuyStoryOpen(false);
    },
    navigateToLeadPage: _navigateToLeadPage(setSubmissionSource, getG4_data(), navigateTo, getPostId(), haveFinance(), helpers.hasTamara(), helpers.getCarBNPLOptions()),
    navigateToColorVariation: _navigateToColorVariation(getPostId(), getG4_data(), navigateToHard)
  };
  var state = {
    howToBuyStoryOpen: howToBuyStoryOpen,
    showContactNumbers: showContactNumbers,
    showOutSideWorkingHoursForm: showOutSideWorkingHoursForm
  };
  var uiHelpers = {
    getCTAGreenButtonText: function getCTAGreenButtonText() {
      var reserveNOWtext = t("احجزها الآن", {
        ns: "web_post_view"
      });
      // requested in [https://syarah.atlassian.net/browse/SE-7875] to remove the Arboun from button text
      // const arbounText = helpers.isCashOnlyCar() ? helpers.getArboun() + t("ريال", {ns: "web_common"}) : "";
      return "".concat(reserveNOWtext);
    }
  };
  return /*#__PURE__*/React.createElement(PostDetailsContext.Provider, {
    value: {
      setPostDetails: setPostDetails,
      postDetails: postDetails,
      helpers: helpers,
      actions: actions,
      state: state,
      uiHelpers: uiHelpers
    }
  }, children);
}